<div fxLayout="column" class="editor-container" >
    <app-grid-view [formOptions]="formOptions"></app-grid-view>
</div>
